import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'; 
import ArrowIcon from '../assets/images/arrow-right.svg' 

function HomeCareers({data}) {
  if (!data) {
    return null; // Correct return for better handling
  }

  return (
    <> 
    <section className="home-careers">
      <Container>
        <Row className="align-items-center">    
          <Col sm="12" lg="7">    
            <div className="home-careers-box">        
              <h2>{data.title}</h2>
              <p>{data.subtitle}</p>
              <Link to={data.btn_link} title={data.btn_name} className="custom-bttn"> {data.btn_name} <img className="arrow-icon-img" src={ArrowIcon} alt="" /></Link> 
            </div>
          </Col>
        </Row>        
      </Container>
    </section>
    </>
  )
}
export default HomeCareers